function normalizeCurrency(currency) {
  return currency?.toString().toUpperCase() || "";
}

function toNumber(value) {
  const numberValue = parseFloat(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
}

function getCurrencyUnitsPerEur(wallet, currency) {
  const normalizedCurrency = normalizeCurrency(currency);
  if (!normalizedCurrency) {
    return 0;
  }

  if ("EUR" === normalizedCurrency) {
    return 1;
  }

  const rate = wallet?.r?.find(item => {
    const rateCurrency = normalizeCurrency(item.c).split("/")[0];
    return rateCurrency === normalizedCurrency;
  });

  return toNumber(rate?.r);
}

export function getMoneyRatio(wallet, currency) {
  const normalizedCurrency = normalizeCurrency(currency);
  if (!normalizedCurrency) {
    return 0;
  }

  const currencyUnitsPerEur = getCurrencyUnitsPerEur(wallet, normalizedCurrency);
  return 0 === currencyUnitsPerEur ? 0 : 1 / currencyUnitsPerEur;
}

export function convertCurrencyAmount({ wallet, amount, sourceCurrency, targetCurrency }) {
  const sourceAmount = toNumber(amount);
  const normalizedSourceCurrency = normalizeCurrency(sourceCurrency);
  const normalizedTargetCurrency = normalizeCurrency(targetCurrency);

  if (!normalizedSourceCurrency || !normalizedTargetCurrency) {
    return 0;
  }

  if (normalizedTargetCurrency === normalizedSourceCurrency) {
    return sourceAmount;
  }

  const sourceRatio = getMoneyRatio(wallet, normalizedSourceCurrency);
  const targetRatio = getMoneyRatio(wallet, normalizedTargetCurrency);
  if (0 === sourceRatio || 0 === targetRatio) {
    return 0;
  }

  return sourceAmount * sourceRatio / targetRatio;
}
